import { gql } from '@apollo/client'

export const ADD_WALLET_TRANSACTION = gql`
    mutation AddWalletTransaction($tranxType: TRANX_TYPE!, $userEmail: EmailAddress!, $tranx: WalletTranxInput!) {
        addWalletTransaction(tranx_type: $tranxType, user_email: $userEmail, tranx: $tranx) {
            code
            success
            message
        }
    }
`
